import React from "react";
import {
    Dialog,
    DialogContent,
    IconButton,
    Box,
    Typography,
    Avatar,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function TeamModal({ open, onClose, member }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogContent
                sx={{
                    p: { xs: 2, md: 2.5 },
                    background: "var(--preto)",
                    position: "relative",
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 10,
                        top: 10,
                        zIndex: 2,
                        bgcolor: "rgba(255,255,255,0.08)",
                        border: "1px solid rgba(255,255,255,0.12)",
                        "&:hover": { bgcolor: "rgba(255,255,255,0.12)" },
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                    <Avatar
                        src={member?.avatarUrl}
                        alt={member?.name}
                        sx={{
                            width: 72,
                            height: 72,
                            border: "2px solid rgba(172,201,14,0.55)",
                        }}
                    />
                    <Box>
                        <Typography sx={{ fontWeight: 950, fontSize: 20 }}>
                            {member?.name || "Membro"}
                        </Typography>
                        <Typography sx={{ color: "rgba(255,255,255,0.74)" }}>
                            {member?.role || "Função"}
                        </Typography>
                    </Box>
                </Stack>

                <Typography sx={{ color: "rgba(255,255,255,0.82)", lineHeight: 1.7 }}>
                    {member?.bio ||
                        "Escreva aqui uma bio/descrição e o papel desse membro na equipe."}
                </Typography>
            </DialogContent>
        </Dialog>
    );
}